import { createFileRoute } from '@tanstack/react-router'
import ContatosListPage from '@/pages/contatos/contatos-list'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

// Layout route para /dashboard/$dashboardId/contatos
// Este arquivo (route.tsx) serve como layout que envolve todas as rotas filhas
// Usando Directory Routes: dashboard.$dashboardId.contatos/route.tsx
// route.tsx = layout route (sempre renderizado)
// $id.tsx = rota filha renderizada no <Outlet />
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/contatos',
)({
  component: function ContatosListRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.CONTATOS} dashboardId={dashboardId}>
        <ProtectedRoute
          anyOf={[CAPABILITIES.CONTATOS_ALL, CAPABILITIES.CONTATOS_OWN]}
          dashboardId={dashboardId}
        >
          <ContatosListPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
